import React from 'react'
import { Helmet } from 'react-helmet'


const educationInfo =  [
    {
    "id": 1,
    "name": "Rahman Mahbubur",
    "job":"Software Developer",
    "section":"Career stuffs, Certificate",
    "hobby":"Traveling",
    "location":"Tokyo"
   
    },
    {
    "id": 2,
    "name": "Ms.Fariha Rahman",
    "job":"Student",
    "section":"University",
    "hobby":"Gardening",
    "location":"Chittagong"
    },
    {
    "id": 3,
    "name": "Mr. kibria",
    "job":"Teacher",
    "section":"College",
    "hobby":"Traveling",
    "location":"Dhaka"
    },
    {
    "id": 4,
    "name": "Mr. Himel",
    "job":"Teacher",
    "section":"school",
    "hobby":"Swimming",
    "location":"Chittagong"
    },
   
  
]

function BackLink() {
  return (

    <>
    
   
    <div className='px-6 pt-5'>

      <Helmet>
        <title>Life Long 365</title>
        <meta 
           name='description'
           content='skilled people'
         />
      </Helmet>

         <img style={{ height: 420, width:'100%', objectFit:'cover' }} src="https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="bloom girl image"></img>
       <h1 className="lg:text-3xl font-bold mt-12 mb-3" style={{fontWeight:'800',fontFamily:'raleway'}}>LifeLong365 Agenda</h1>
         <p className='pt-2' style={{fontSize:'15px',fontWeight:'400',fontFamily:'raleway'}}>LifeLong365 is a platform that enables individuals to make informed decisions about their academic area as well as career paths by providing them with insights into the job market, industry trends, and employment opportunities. By staying up-to-date with the latest developments in their field, people can identify the skills and knowledge they need to acquire to progress in their careers.</p>

       <h1 className="lg:text-3xl font-bold my-3" style={{fontWeight:'800',fontFamily:'raleway'}}>Our Vision and mission</h1>
         <p className='pt-2' style={{fontSize:'15px',fontWeight:'400',fontFamily:'raleway'}}>LifeLong365's mission is to help people acquire new skills and knowledge through various resources such as online courses, books, and networking events. This enables individuals to improve their job performance, take on new roles and responsibilities, and advance their careers to the next level.</p>
       <h1 className="lg:text-3xl font-bold my-3" style={{fontWeight:'800',fontFamily:'raleway'}}>Our core values</h1>
         <p className='pt-3 pb-6' style={{fontSize:'15px',fontWeight:'400',fontFamily:'raleway'}}>LifeLong365 is a platform for helping people make informed decisions, acquire new skills and knowledge, and build their academic networks, and professional networks, all of which are vital for career advancement.</p>
    </div>

{/* list starts: */}


<div className="overflow-x-auto my-12">
<h1 className="lg:text-3xl font-bold my-3 ml-6" style={{fontWeight:'600',fontFamily:'raleway'}}>Admin Panel</h1>
  <table className="table w-full">
    {/* head */}
    <thead>
      <tr>
        <th></th>
        <th>Name</th>
        <th>Job</th>
        <th>Section</th>
        <th>Hobby</th>
        <th>Favorite Quote</th>
      </tr>
    </thead>
    <tbody>
      {/* row 1 */}
      {educationInfo.map((content) => (
      <tr>
        <th>{content.id}</th>
        <td>{content.name}</td>
        <td>{content.job}</td>
        <td>{content.section}</td>
        <td>{content.hobby}</td>
        <td>{content.location}</td>
        
      </tr>
      )
      )
      }
    </tbody>
  </table>
</div>
</>

  )
}

export default BackLink